import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class AppRouteReuseStrategy implements RouteReuseStrategy {
  private cache = new Map<string, DetachedRouteHandle>();
  private readonly nonReusablePaths = new Set(['firmware-update/:deviceId']);

  private key(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(r => r.routeConfig?.path ?? '')
      .filter(Boolean)
      .join('/');
  }

  private isReusable(route: ActivatedRouteSnapshot): boolean {
    const path = route.routeConfig?.path;
    return !!path && !this.nonReusablePaths.has(path);
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.isReusable(route);
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    this.cache.set(this.key(route), handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return this.isReusable(route) && this.cache.has(this.key(route));
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return this.cache.get(this.key(route)) ?? null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (!this.isReusable(future) || !this.isReusable(curr)) {
      return false;
    }

    return future.routeConfig === curr.routeConfig;
  }
}
